// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
// import bootstrap from "bootstrap";
// import Parallax from 'parallax-js'
import $ from "jquery";
window.jQuery = $;
window.$ = $;
require ('jquery-parallax.js');
var Masonry = require('masonry-layout');
import mediumZoom from 'medium-zoom';
require('paroller.js');
import 'slick-carousel';
// import WOW from'wowjs'
// const WOW = require('wowjs');

const svgClose = `
<svg class="navbar-toggler-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="24" height="24">
  <path stroke="white" stroke-width="2" d="M5 5 L25 25"/>
  <path stroke="white" stroke-width="2" d="M25 5 L5 25"/>
</svg>`;

// import simpleParallax from 'simple-parallax-js';


const bootstrap = window.bootstrap = require('bootstrap');
// var parallax_images = document.getElementsByClassName('parallax');
// new simpleParallax( parallax_images,{
//     overflow: false
//     // scale: 1.05
//     // orientation: 'right'
// });

var stickyHeaderHeight = 200 ;

if(document.querySelector('.grid')){
    var msnry = new Masonry( '.grid', {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
}



let slick_responsive =  [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        autoplay: true,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
      }
    },
    // {
    //   breakpoint: 480,
    //   settings: {
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     autoplay: true,
    //   }
    // }
  ];


$('.wc-block-product-template__responsive').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 3,
    slidesToScroll : 1,
    arrows: true,
    dots: false,
    responsive: slick_responsive,
    prevArrow: '<button class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
    nextArrow: '<button class="slick-next"><i class="fas fa-chevron-right"></i></button>'
});

 // Fermer le mùenu en swippant à gauche
    document.addEventListener('DOMContentLoaded', function() {
        const menu = document.getElementById('navbarMain');
        const bsCollapse = new bootstrap.Collapse(menu, { toggle: false });
        
        let touchStartX = 0;
        let touchEndX = 0;

        // On enregistre la position de départ du doigt
        menu.addEventListener('touchstart', e => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        // On calcule la position de fin et la direction
        menu.addEventListener('touchend', e => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, { passive: true });

       

        function handleSwipe() {
             console.log(touchStartX);
        console.log(touchEndX);
            // Si le point de fin est plus à gauche que le point de départ (seuil de 50px)
            if (touchStartX - touchEndX > 50) {
                // On vérifie si le menu est actuellement ouvert avant de fermer
                if (menu.classList.contains('show')) {
                    bsCollapse.hide();
                }
            }
        }
    });


function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

$(function() { 

     /**
     * Anchor smooth scroll
     */
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('[role="tab"]')
      .on('click', function(event) {
          // On-page links
          if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
              && 
              location.hostname == this.hostname
          ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  document.documentElement.scrollTo({
                      top: target.offset().top - stickyHeaderHeight,
                      behavior: "smooth"
                  })
              }
          }
      });

    $('.accordion-collapse').on('shown.bs.collapse', function (e) {
        var $panel = $(this).closest('.accordion-item');
        document.documentElement.scrollTo({
            top: $panel.offset().top - stickyHeaderHeight,
            behavior: "smooth"
        });
    });

    //Clone burger icon to overlay menu
    $('.navbar-fixed-opened').on('show.bs.collapse', function () {
        $('.navbar-closer').remove();
        $('.navbar-fixed-opened').prepend(`<button class="navbar-toggler navbar-closer" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="true" aria-label="Fermer">
        ${svgClose}</button>`);
    }) ;

    // Close menu & overlays when Escape
    $(document).on('keydown', function(e) {
        if (e.key == "Escape") {
            $('#navbarMain').collapse('hide');
            $('.agencea-overlay').removeClass('shown');
        }
    });

    //Wow
    if('function' === typeof WOW){
        new WOW().init();
    }
    

    // Sticky menu
    // if (window.matchMedia("(max-width: 992px)").matches) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 160) {
               $('.brand-logo').addClass('opacity-0');
            } else {
                $('.brand-logo').removeClass('opacity-0');
            } 
        });
    // }

    // $('.dropdown-toggle').dropdown();
    mediumZoom('[data-zoomable]');
    $("[data-paroller-factor]").wrap('<div class="paroller-wrap"></div>');
    $("[data-paroller-factor]").paroller();
    

    if (typeof jarallax === 'function') {
        // jarallaxVideo();
        jarallax(document.querySelectorAll('.jarallax'), {
            speed: 0.2
        });
    }

    // Menu
    $(".dropdown").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
            dropdownMenu.parent().toggleClass("open");
        }
    });


    $(document).on('click', '.navbar .dropdown-toggle', function(){
        if (window.matchMedia("(min-width: 992px)").matches) {
            window.location.href= $(this).attr('href');
        }
    });

    // Search form full screen [search_full_screen]
    $(document).on('click', '#search-full-screen__toggle', function(){
        $('#search-full-screen__target')
            .prepend(`<button class="navbar-toggler agencea-overlay__close" type="button" aria-controls="search-full-screen__form" aria-expanded="true" aria-label="Fermer">
        ${svgClose}</button>`)
            .addClass('shown');
    });

    $(document).on('click', '.agencea-overlay__close', function(){
        $('.agencea-overlay')
            .removeClass('shown')
            .find('.agencea-overlay__close').remove();
           
    });
   



    // Counters
    $(window).on('scroll', function(){
        $('.count, .down_count').each(function () {
            if(isInViewport($(this)[0])){
                $(this).addClass('countAnimated');
            }
        });

        $('.count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });

        // Down Counters
        $('.down_count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',10).animate({
                    Counter: $(this).text()
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });
    });
      


   //Scroll back to top
		
		var progressPath = document.querySelector('.progress-wrap path');
        if(progressPath){
            var pathLength = progressPath.getTotalLength();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
            progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
            progressPath.style.strokeDashoffset = pathLength;
            progressPath.getBoundingClientRect();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
            var updateProgress = function () {
                var scroll = $(window).scrollTop();
                var height = $(document).height() - $(window).height();
                var progress = pathLength - (scroll * pathLength / height);
                progressPath.style.strokeDashoffset = progress;
            }
            updateProgress();
            $(window).scroll(updateProgress);	
            var offset = 150;
            // var duration = 550;
            jQuery(window).on('scroll', function() {
                if (jQuery(this).scrollTop() > offset) {
                    jQuery('.progress-wrap').addClass('active-progress');
                } else {
                    jQuery('.progress-wrap').removeClass('active-progress');
                }
            });				
            jQuery('.progress-wrap').on('click', function(event) {
                event.preventDefault();
                document.documentElement.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
                return false;
            });
        }


    /**
     * Map dealers
     */

    if($('#contact_map').length > 0){
    

        $.post(agencea.ajaxurl, {'action':'geocode_contact_address'}, function(response){
            if(response.lat_lng != ""){
                var contactmap = L.map('contact_map', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([response.lat_lng.lat, response.lat_lng.lng], 15);

                L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
                    maxZoom: 18,
                    // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                    //     'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1
                }).addTo(contactmap);
           
                var marker = L.marker([response.lat_lng.lat, response.lat_lng.lng], {title:response.name+'<br>'+response.address}).addTo(contactmap);
                marker.bindPopup(response.name+'<br>'+response.address).openPopup();
                    
            }
        
        });

       

        // $('.dealers-list > li').on('click', function(){
        //     var id = $(this).data('id') ;
        //     var _marker = dealersmap.getMarkerById(id);
        //     _marker.fire('click');
        // });
    }


    if($('#dealers_map').length > 0){
        // Get marker by ID
        L.Map.include({
            getMarkerById: function (id) {
                var marker = null;
                this.eachLayer(function (layer) {
                    if (layer instanceof L.Marker) {
                        if (layer.options.id === id) {
                            marker = layer;
                        }
                    }
                });
                return marker;
            }
        });


        var dealersmap = L.map('dealers_map', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([44.8947086,-0.2065675], 2);

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
            maxZoom: 18,
            //attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
           //     'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1
        }).addTo(dealersmap);

        var franceBounds = L.latLngBounds(
            [41.33, -5.14],
            [51.09, 9.56]
        );
        dealersmap.fitBounds(franceBounds);

        var markers = [] ;

        $.get('/wp-json/wp/v2/dealer', function(response){
            if(response.length > 0){
                for (let i = 0; i < response.length; i++) {
                    const element = response[i];
                    if(element.acf.latitude != '' && element.acf.longitude != ''){
                        var marker = L.marker([element.acf.latitude, element.acf.longitude], {title:element.title.rendered,id:element.id}).addTo(dealersmap);
                       
                        var popupContent = "<strong>" + element.title.rendered + "</strong><br>";

                       // popupContent += "Latitude : " + element.acf.latitude + "<br>";
                        //popupContent += "Longitude : " + element.acf.longitude + "<br>";

                        if (element.acf.address_1) {
                            popupContent += element.acf.address_1 + "<br>";
                        }

                        if (element.acf.zipcode || element.acf.city) {
                            var location = "";
                            if (element.acf.zipcode) location += element.acf.zipcode + " ";
                            if (element.acf.city) location += element.acf.city;
                            popupContent += location + "<br>";
                        }

                        if (element.acf.phone) {
                            popupContent += `<i class="fas fa-phone"></i> <a href="tel:${element.acf.phone}">${element.acf.phone}</a><br>`;
                        }

                        if (element.acf.email) {
                            popupContent += `<i class="fas fa-envelope"></i> <a href='mailto:${element.acf.email}'>${element.acf.email}</a><br>`;
                        }

                        if (element.acf.website) {
                            popupContent += `<i class="fas fa-link"></i> <a href="${element.acf.website}" target="_blank">Visiter le site web</a><br>`;
                        }

                        marker.bindPopup(popupContent);
                        markers.push(marker);
                        marker.on('click', onClick);
                    }
                    
                }
            }
        
        });

        function onClick(e) {
            var id = e.target.options.id ;
            $('.dealers-list').find('li').removeClass('list-group-item-primary');
            $('.dealers-list').find('[data-id="'+id+'"]').addClass('list-group-item-primary');
            $('.dealers-list').find('[data-id="'+id+'"]').parents('.accordion-item').find('.accordion-button.collapsed').trigger('click');
        }

        $('.dealers-list > li').on('click', function(){
            var id = $(this).data('id') ;
            var _marker = dealersmap.getMarkerById(id);
            _marker.fire('click');
        });
    }

    $('.hero2:not(.related.products)').after('<div class="hero2-append fullwidth"><div class="hero2-append-inner"></div></div>')

   

    
   
});





